import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Flex,
  Text,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Image,
  Button,
} from "@chakra-ui/react";
import { Card } from "@components";
import { SendLink } from "@components/ActivityTypes/Send";
import sendIcon from "@assets/svg/icon-send.svg";
import { LinkIcon, ArrowUpRight } from "@components/Svg";

const SendView = ({ handleClick, handleView, activity }) => {
  const [hasJustAcknowledged, setHasJustAcknowledged] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const profile = useSelector((state) => state.profile.data);

  const isAcknowledgedOnServer = !!activity?.response?.some(
    (res) => res?.user?.userId === profile?._id && res.viewedAt
  );
  const hasViewed = hasJustAcknowledged || isAcknowledgedOnServer;

  const handleGotItClick = async () => {
    if (hasViewed || !handleView) {
      return;
    }

    setHasJustAcknowledged(true);
    try {
      await handleView(activity);
    } catch (error) {
      setHasJustAcknowledged(false);
    }
  };

  const handleOpenLinkClick = () => {
    if (handleClick) {
      handleClick(activity);
    }
  };

  return (
    <Card p={2} borderRadius="12px" background="white" mb={2}>
      <AccordionItem border={0}>
        {({ isExpanded: accordionExpanded }) => {
          // Update state when accordion expands/collapses
          if (accordionExpanded !== isExpanded) {
            setIsExpanded(accordionExpanded);
          }

          return (
            <>
              <Flex justifyContent="space-between" alignItems="flex-start">
                <Flex
                  alignItems="flex-start"
                  justifyContent="space-between"
                  mr="8px"
                >
                  <Image mr="8px" src={sendIcon} width="24px" height="24px" />
                  <Text fontSize="12px" color="dark.400" fontWeight={600}>
                    {activity?.link
                      ? activity?.title || activity?.content
                      : activity?.content || activity?.title}
                  </Text>
                </Flex>
                <AccordionButton
                  borderRadius="full"
                  w="inherit"
                  p="0"
                  bg="transparent"
                  fontSize="12px"
                  color="gray.400"
                  _hover={{ bg: "gray.100" }}
                  _active={{ bg: "transparent" }}
                >
                  <AccordionIcon />
                </AccordionButton>
              </Flex>
              <AccordionPanel p="10px 0">
                {activity.link ? (
                  <Flex direction="column" gap={3}>
                    <SendLink
                      text={[activity.link]}
                      handleClick={() => handleClick(activity)}
                      beforeIcon={
                        <LinkIcon color="dark.200" mr={2} width="12px" />
                      }
                      afterIcon={
                        <ArrowUpRight
                          ml={1}
                          color="green.500"
                          mr={1}
                          width="10px"
                        />
                      }
                    />
                    <Flex gap={2}>
                      <Button
                        size="sm"
                        colorScheme="blue"
                        variant="outline"
                        onClick={handleGotItClick}
                        isDisabled={hasViewed}
                        flex={1}
                        data-testid="send-activity-got-it-button"
                      >
                        {hasViewed ? "Got it ✓" : "Got it"}
                      </Button>
                      <Button
                        size="sm"
                        colorScheme="green"
                        onClick={handleOpenLinkClick}
                        flex={1}
                        data-testid="send-activity-open-link-button"
                      >
                        Open link
                      </Button>
                    </Flex>
                  </Flex>
                ) : (
                  <Button
                    size="sm"
                    colorScheme="blue"
                    variant="outline"
                    onClick={handleGotItClick}
                    isDisabled={hasViewed}
                    data-testid="send-activity-got-it-button"
                  >
                    {hasViewed ? "Got it ✓" : "Got it"}
                  </Button>
                )}
              </AccordionPanel>
            </>
          );
        }}
      </AccordionItem>
    </Card>
  );
};

export default SendView;
